import { Trigger } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ChoiceButton, ChoiceButtonBaseIcon } from "../../../../../../shared/ChoiceButton";
import {
	AssignableTravelSegmentType,
	TravelDirection,
	TravelSegmentFormValues,
} from "../../../../shared/types/travelSegment";
import { TravelSegmentCreateDrawer } from "./createTravelSegment/TravelSegmentCreateDrawer";

interface Props {
	availableTypes: AssignableTravelSegmentType[];
	direction: TravelDirection;
	onCreateTravelSegment: (values: TravelSegmentFormValues) => void;
}

export const CreateTravelSegmentChoiceButton: FC<Props> = ({ availableTypes, direction, onCreateTravelSegment }) => {
	const { t } = useTranslation();

	return (
		<Trigger
			render={(props) => (
				<TravelSegmentCreateDrawer
					availableTypes={availableTypes}
					open={props.open}
					onClose={props.handleClose}
					direction={direction}
					onSubmit={async (formValues) => {
						onCreateTravelSegment(formValues);
						return true;
					}}
					onClosed={() => undefined}
				/>
			)}
		>
			{(triggerProps) => (
				<ChoiceButton type="button" {...triggerProps}>
					<ChoiceButtonBaseIcon src="/icons/create_travel_segment.svg" />
					{t("Create new travel segment")}
				</ChoiceButton>
			)}
		</Trigger>
	);
};
